import parseToHsl from 'polished/lib/color/parseToHsl';
import toColorString from 'polished/lib/color/toColorString';

export function lighten(factor: number, color: string): string {
  // S'assurer que le facteur est entre 0 et 1
  const normalizedFactor = Math.max(0, Math.min(1, factor));

  // Convertir la couleur en HSL
  const hsl = parseToHsl(color);

  // Augmenter la luminosité proportionnellement
  // Au lieu de simplement ajouter, on utilise une formule qui donne un effet plus naturel
  // et évite l'éclaircissement excessif
  hsl.lightness = hsl.lightness + (1 - hsl.lightness) * normalizedFactor;

  // Reconvertir en string de couleur
  return toColorString(hsl);
}
